import { render } from "./introduction.vue?vue&type=template&id=4983bd2a&ts=true"
import script from "./introduction.ts?vue&type=script&lang=ts&external"
export * from "./introduction.ts?vue&type=script&lang=ts&external"

import "./introduction.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__